<template>
  <!-- Cached views should provide their activated state to prevent leaking portals
  Leaking may happen when activated-portal used in cached view is wrapped in v-if, e.g breakpoint
  When v-if condition changes to true, inner activated is true even if coming from hidden view
  This may cause rendering content of portal for views that don't set some the-layout portals
  Related issue: https://disciple.kanbanize.com/ctrl_board/58/cards/54614/details/ -->
  <portal v-if="activated && cachedViewActivated" :to="to">
    <slot />
  </portal>
</template>

<script>
import { useActivatedState } from "@/composables/useActivatedState.js"

export default {
  props: {
    to: {
      type: String,
      required: true
    },
    cachedViewActivated: {
      type: Boolean,
      default: true
    }
  },
  setup() {
    const { activated } = useActivatedState()
    return { activated }
  }
}
</script>
